const Index = resolve => require.ensure([], () => resolve(require('./Index.vue')), 'group-research');
const Show = resolve => require.ensure([], () => resolve(require('./Show.vue')), 'group-research');
const Print = resolve => require.ensure([], () => resolve(require('./Print.vue')), 'group-research');
const Down = resolve => require.ensure([], () => resolve(require('./Down.vue')), 'group-research');

export default [{
  path: '/admin/research/activities/:id/projects',
  name: 'admin/research/projects',
  component: Index,
  meta: {
    title: '教改项目',
    layout: 'admin',
  },
}, {
  path: '/admin/research/projects/:id',
  name: 'admin/research/projects/id',
  component: Show,
  meta: {
    title: '详情',
    layout: 'admin',
  },
}, {
  path: '/print',
  name: 'print',
  component: Print,
  meta: {
    title: '打印',
  },
}, {
  path: '/down',
  name: 'down',
  component: Down,
  meta: {
    title: '打印评审意见表',
  },
}];



// WEBPACK FOOTER //
// ./src/pages/admin/research/projects/index.js